import React, {useMemo, useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import objectPath from 'object-path';
import SVG from 'react-inlinesvg';
import {useHtmlClassService} from '../../_core/MetronicLayout';
import {toAbsoluteUrl} from '../../../_helpers';
import { whiteLabelService } from 'src/services/whitelabel';

export function Brand() {
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      brandClasses: uiService.getClasses('brand', true),
      asideSelfMinimizeToggle: objectPath.get(uiService.config, 'aside.self.minimize.toggle'),
      headerLogo: uiService.getLogo(),
      headerStickyLogo: uiService.getStickyLogo()
    };
  }, [uiService]);

  const [img, setImg] = useState(layoutProps.headerLogo)


  useEffect(() => {
    (async () => {
      try {
        const { data } = await whiteLabelService.getImageClient()

        if (data.data) {
          setImg(data.data)
        }
      } catch {
        setImg(layoutProps.headerLogo)
      }
    })()
  }, [])

  return (
    <>
      {/* begin::Brand */}
      <div className={`brand flex-column-auto ${layoutProps.brandClasses}`} id='kt_brand'>
        {/* begin::Logo */}
        <Link to='' className='brand-logo'>
          <img 
            alt='logo' 
            src={img} 
            onError={(err)=> {
              setImg(layoutProps.headerLogo)
            }}
            style={{
              width: '86px',
              height: '27px',
              objectFit:'cover'
            }}
            />
        </Link>
        {/* end::Logo */}
      </div>
      {/* end::Brand */}
    </>
  );
}
